import { Content } from '../Content';
import { Quizzes } from '../Quizzes';

import { HeaderWrapper, ItemWrapper, TabsWrapper, Wrapper } from './BaseContentTabs.styles';
import { useBaseCourseTabs } from './useBaseContentTabs';

import { ActivityForm } from '@/components/ActivityForm';
import { CourseStepTab } from '@/components/CourseStepTab';
import { TasksPanel } from '@/components/TasksPanel';
import { ECourseStep } from '@/types';

const COURSE_TABS_ITEMS = {
  [ECourseStep.CONTENT]: Content,
  [ECourseStep.TASKS_PANEL]: TasksPanel,
  [ECourseStep.QUIZZES]: Quizzes
};

export const BaseContentTabs: React.FC = () => {
  const { handleTabChange, items, activeTab, courseId } = useBaseCourseTabs();

  const Item = COURSE_TABS_ITEMS[activeTab as keyof typeof COURSE_TABS_ITEMS];

  if (!Item) return null;

  return (
    <Wrapper>
      <HeaderWrapper>
        <TabsWrapper>
          {items.map(item => (
            <CourseStepTab
              onClick={() => handleTabChange(item.key)}
              isActive={item.key === activeTab}
              key={item.key}
              label={item.label}
              subMenuItems={item.subMenuItems}
            />
          ))}
        </TabsWrapper>
      </HeaderWrapper>
      <ItemWrapper>
        <Item courseId={courseId} />
      </ItemWrapper>
      <ActivityForm isParentCourse />
    </Wrapper>
  );
};
